export default "__VITE_ASSET__CqJ6Ol$h__"